import { createSlice } from "@reduxjs/toolkit";

const InitialState = {};

export const RequestsSlice = createSlice({
  name: "requests",
  initialState: {
    ...InitialState,
  },

  reducers: {
    setRequestToState: (state, action) => {
      const { key, data } = action.payload;
      state[key] = data;
    },
    unsetRequestFromState: (state, action) => {
      const { keys } = action.payload;
      keys.forEach((key) => {
        state[key] = null;
      });
    },
  },
});

export const { setRequestToState, unsetRequestFromState } =
  RequestsSlice.actions;

export const getAllRequests = (state) => {
  return state.requests;
};

export const getRequestByMethod = (methodName) => (state) => {
  return state.requests[methodName] || null;
};

export default RequestsSlice.reducer;
